import { createId } from '~/lib/NanoId'

export class ContactSubmissionForm {
  FirstName: string
  LastName: string
  Email: string
  Company: string
  Phone: string
  Subject: string
  Message: string
  ConsentGeneral: boolean
  UserLanguage: string
  static rules = {
    FirstName: {
      required: true
    },
    LastName: {
      required: true
    },
    Email: {
      required: true,
      email: true
    },
    Company: {},
    Phone: {},
    Subject: {
      required: true
    },
    Message: {
      required: true
    },
    ConsentGeneral: {
      required: {
        allowFalse: false
      }
    },
    UserLanguage: {
      required: true
    }
  }
}

export class ContactSubmission {
  Id: string
  CreatedAt: string
  Email: string
  FirstName: string
  LastName: string
  Company: string
  Phone: string
  Subject: string
  Message: string
  Office: string
  Label: string
  Hostname: string
  UserIp: string
  ConsentGeneral: boolean
  ConsentAnalyze: boolean
  ConsentNewsletter: boolean
  ConsentTailoredOffers: boolean
  UserLanguage: string

  public constructor(init?: Partial<ContactSubmission>) {
    Object.assign(this, init)
  }

  static create(
    formData: ContactSubmissionForm,
    label: string,
    hostname: string
  ) {
    const id = createId()
    const now = new Date().toISOString()
    const data: ContactSubmission = {
      Id: id,
      CreatedAt: now,
      ...formData,
      Office: null,
      Label: label,
      Hostname: hostname,
      UserIp: null,
      ConsentAnalyze: true,
      ConsentNewsletter: true,
      ConsentTailoredOffers: true
    }
    return new ContactSubmission(data)
  }
}
